import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LoadingModule } from 'src/app/shared/components';
import { AgilizeAttendancePageComponent } from './agilize-attendance-page.component';
import { NgxMaskModule } from 'ngx-mask';
import { AddressPipeModule } from 'src/app/shared/pipes';

@NgModule({
    declarations: [
        AgilizeAttendancePageComponent
    ],
    exports: [
        AgilizeAttendancePageComponent,
    ],
    imports: [
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        AngularSvgIconModule,
        LoadingModule,
        BrowserModule,
        ReactiveFormsModule,
        NgxMaskModule,
        AddressPipeModule
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AgilizeAttendancePageModule { }
